import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

// to compensate for the <Label /> styles having a 4px bot padding (for centering purpose)
export const labelWithTooltipStyles = css`
    padding-top: ${Spacing["2XS"]};
`;
